import { Link, useNavigate } from "react-router-dom";
import brand from "../assets/img/brand-nav.png";
import axios from "axios";
import { useForm } from "react-hook-form";
import AboutThisProject from "../components/AboutThisProject";
import { toast } from "react-toastify";

function RegisterPage() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      const response = await toast.promise(
        axios({
          method: "post",
          url: process.env.REACT_APP_API_URL + "/api/customers",
          data: data,
        }),
        {
          pending: "Saving data...",
          success: "Successfully registered",
          error: "Invalid data",
        }
      );
      navigate("/login");
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="login-page animate__animated animate__fadeIn">
      <AboutThisProject />
      <div className="container my-0 px-4 px-lg-5">
        <div className="row gx-4 gx-lg-5 justify-content-center align-items-center mb-5 h-100">
          <div
            id="form-card"
            className="col-md-10 col-lg-8 col-xl-7 btn-light rounded shadow"
          >
            <div className="contenido-card d-flex flex-column align-items-center">
              <div className="d-flex flex-column align-items-center">
                <Link to="/">
                  <img src={brand} className="img-fluid mb-4" alt="" />
                </Link>
              </div>
              <form onSubmit={handleSubmit(onSubmit)} id="contactForm">
                <div className="input-group">
                  <div className="me-3">
                    <label className="pt-4" htmlFor="firstname">
                      Name
                    </label>
                    <input
                      autoComplete="off"
                      className="form-control bg-light"
                      id="firstname"
                      type="text"
                      placeholder="Write yor firstname..."
                      {...register("firstname", {
                        required: true,
                        maxLength: 20,
                      })}
                    />
                    {errors.firstname && (
                      <span className="f-roboto fs-7 text-danger d-block">
                        This field is required
                      </span>
                    )}
                  </div>

                  <div>
                    <label className="pt-4" htmlFor="lastname">
                      Lastname
                    </label>
                    <input
                      autoComplete="off"
                      id="lastname"
                      className="form-control bg-light"
                      type="text"
                      placeholder="Write you lastname..."
                      {...register("lastname", {
                        required: true,
                        maxLength: 20,
                      })}
                    />
                    {errors.lastname && (
                      <span className="f-roboto fs-7 text-danger d-block">
                        This field is required
                      </span>
                    )}
                  </div>
                </div>

                <label htmlFor="email" className="mt-3">
                  E-mail
                </label>
                <input
                  autoComplete="off"
                  name="email"
                  className="form-control bg-light"
                  id="email"
                  type="email"
                  placeholder="Write your email address..."
                  {...register("email", {
                    required: true,
                    maxLength: 20,
                  })}
                />
                {errors.email && (
                  <span className="f-roboto fs-7 text-danger d-block">
                    This field is required
                  </span>
                )}

                <label htmlFor="password" className="mt-3">
                  Password
                </label>
                <input
                  autoComplete="off"
                  className="form-control bg-light"
                  id="password"
                  type="password"
                  placeholder="Choose a password..."
                  {...register("password", {
                    required: true,
                    maxLength: 20,
                  })}
                />
                {errors.password && (
                  <span className="f-roboto fs-7 text-danger d-block">
                    This field is required
                  </span>
                )}

                <label htmlFor="phoneNumber" className="mt-3">
                  Phone Number
                </label>
                <input
                  autoComplete="off"
                  className="form-control bg-light"
                  id="phoneNumber"
                  type="phoneNumber"
                  placeholder="Write your phone number..."
                  {...register("phoneNumber", {
                    required: true,
                    maxLength: 20,
                  })}
                />
                {errors.phoneNumber && (
                  <span className="f-roboto fs-7 text-danger d-block">
                    This field is required
                  </span>
                )}

                <label htmlFor="address" className="mt-3">
                  Address
                </label>
                <input
                  autoComplete="off"
                  className="form-control bg-light"
                  id="address"
                  type="address"
                  placeholder="Write your address..."
                  {...register("address", {
                    required: true,
                    maxLength: 20,
                  })}
                />
                {errors.address && (
                  <span className="f-roboto fs-7 text-danger d-block">
                    This field is required
                  </span>
                )}

                <br />

                <button
                  className="btn btn-yellow px-3 text-uppercase rounded mt-3"
                  type="submit"
                >
                  Send
                </button>
              </form>
              <div>
                <p className="pt-3 mb-5 text-secondary">
                  If you already have an account, login
                  <strong className="ms-1">
                    <Link to="/login" className="text-decoration-none link">
                      here
                    </Link>
                  </strong>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
